type ParsedText = {
  text: string;
  url?: string;
};

const PROTOCOL = /^(http|https|mailto):/;
const LINKABLE = /(?:[\w+.-]+@(?:[\w-]+\.)+(?:com|gov|net|org|au|ca|co|me))|(?:(?:https?:\/\/)?(?:[\w-]+\.)+(?:com|gov|net|org|au|ca|co|me)(?::\d+)?(?:\/[\w/%=.-]*(?:\?[\w%=&.-]*)?(?:#[\w%=&.-]*)?)?)/gi;

export default function parseTextForLinks(
  input: string | null | undefined,
): Array<ParsedText> {
  let results = [];
  let lastIndex = 0;
  let inputText = input || '';
  inputText.replace(LINKABLE, (fullMatch, startIndex) => {
    let matchedText = isValidEnding(fullMatch)
      ? fullMatch
      : fullMatch.slice(0, -1);
    if (startIndex > lastIndex) {
      results.push({ text: inputText.slice(lastIndex, startIndex) });
    }
    results.push({
      text: matchedText,
      url: normalizeURL(matchedText),
    });
    lastIndex = startIndex + matchedText.length;
    return matchedText;
  });
  if (lastIndex === 0 || lastIndex < inputText.length) {
    results.push({ text: inputText.slice(lastIndex) });
  }
  return results;
}

function isValidEnding(url: string) {
  switch (url.slice(-1)) {
    case '.':
    case '?': {
      return false;
    }
  }
  return true;
}

function normalizeURL(url: string) {
  if (PROTOCOL.test(url)) {
    return url;
  }
  // If it has `@` then assume it's an email address.
  return url.indexOf('@') !== -1 ? `mailto:${url}` : `http://${url}`;
}
